import React from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  Stack,
  Avatar,
  TextField,
  MenuItem,
  Drawer,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PhotoCamera from '@mui/icons-material/PhotoCamera';

const AddAdminDrawer = ({
  open,
  onClose,
  newData,
  setNewData,
  addPreview,
  onFileChange,
  onSubmit,
  isSubmitting,
}) => {
  const setField = (field) => (e) =>
    setNewData({ ...newData, [field]: e.target.value });

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{ zIndex: 3000 }}
      PaperProps={{ sx: { width: { xs: '100%', sm: 500 }, p: 3 } }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 800, color: '#2B3674' }}>
          Nouvel Administrateur
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ overflowY: 'auto', maxHeight: 'calc(100vh - 150px)', pr: 1 }}>
        <Stack spacing={2.5}>
          {/* Section Photo */}
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <Avatar
              src={addPreview}
              sx={{
                width: 100,
                height: 100,
                mx: 'auto',
                mb: 1,
                border: '2px dashed #4318FF',
              }}
            />
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="add-photo-upload"
              type="file"
              onChange={onFileChange}
            />
            <label htmlFor="add-photo-upload">
              <Button variant="outlined" component="span" size="small" startIcon={<PhotoCamera />}>
                Photo requise
              </Button>
            </label>
          </Box>

          {/* Champs Identité */}
          <Stack direction="row" spacing={2}>
            <TextField label="Nom" fullWidth value={newData.nom_user} onChange={setField('nom_user')} />
            <TextField
              label="Prénom"
              fullWidth
              value={newData.prenom_user}
              onChange={setField('prenom_user')}
            />
          </Stack>

          <TextField label="Email" fullWidth value={newData.email_user} onChange={setField('email_user')} />
          <TextField
            label="Mot de passe"
            type="password"
            fullWidth
            value={newData.password_user}
            onChange={setField('password_user')}
          />

          {/* Localisation & Contact */}
          <TextField
            label="Adresse"
            fullWidth
            value={newData.addresse_user}
            onChange={setField('addresse_user')}
          />

          <Stack direction="row" spacing={2}>
            <TextField label="Ville" fullWidth value={newData.ville_user} onChange={setField('ville_user')} />
            <TextField
              label="Code Postal"
              fullWidth
              value={newData.cp_user}
              onChange={setField('cp_user')}
            />
          </Stack>

          <Stack direction="row" spacing={2}>
            <TextField
              label="Province"
              fullWidth
              value={newData.province_user}
              onChange={setField('province_user')}
            />
            <TextField
              label="Téléphone"
              fullWidth
              value={newData.phone_user}
              onChange={setField('phone_user')}
            />
          </Stack>

          {/* Rôles et État */}
          <Stack direction="row" spacing={2}>
            <TextField select label="Rôle" fullWidth value={newData.role_user} onChange={setField('role_user')}>
              <MenuItem value="1">Super Admin</MenuItem>
              <MenuItem value="2">Admin</MenuItem>
            </TextField>
            <TextField select label="État" fullWidth value={newData.etat_user} onChange={setField('etat_user')}>
              <MenuItem value="active">Actif</MenuItem>
              <MenuItem value="inactive">Inactif</MenuItem>
            </TextField>
          </Stack>

          <Button
            fullWidth
            variant="contained"
            onClick={onSubmit}
            disabled={isSubmitting}
            sx={{ py: 1.5, borderRadius: '12px', bgcolor: '#4318FF', fontWeight: 700, mt: 2 }}
          >
            {isSubmitting ? 'Création en cours...' : 'Créer le compte'}
          </Button>
        </Stack>
      </Box>
    </Drawer>
  );
};

export default AddAdminDrawer;
